var _g, _path, _g2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascriptIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.924,2.924) scale(0.966,0.966)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "none",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#333333",
    strokeWidth: 6,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,150.5v-129h129v129z",
    fill: "#ffd600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8445,118.06008c2.47967,4.02767 5.17433,7.88692 10.88258,7.88692c4.7945,0 7.31,-2.38292 7.31,-5.67958c0,-3.94525 -2.6015,-5.34633 -7.87617,-7.64325l-2.89175,-1.23267c-8.34558,-3.54033 -13.89617,-7.9765 -13.89617,-17.34692c0,-8.63583 6.61125,-15.20767 16.942,-15.20767c7.35658,0 12.642,2.54775 16.45467,9.21992l-9.0085,5.75842c-1.98158,-3.54033 -4.12442,-4.93425 -7.44617,-4.93425c-3.38983,0 -5.53625,2.13925 -5.53625,4.93425c0,3.45433 2.15,4.85183 7.11292,6.99108l2.89175,1.23267c9.83625,4.18892 15.38325,8.46742 15.38325,18.08508c0,10.363 -8.18433,16.04258 -19.17083,16.04258c-10.74642,0 -16.84883,-5.39292 -20.24583,-12.06867zM64.328,118.35392c1.81317,3.2465 4.56875,5.74408 8.53192,5.74408c3.79117,0 5.97342,-1.49783 5.97342,-7.32075v-37.94392h11.94325v39.77858c0,12.06508 -6.99825,17.55475 -17.21792,17.55475c-9.23425,0 -15.89925,-6.2565 -18.61542,-12.06867z",
    fill: "#000001"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "miter"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,150.5v-129h129v129z",
    fill: "#ffd600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8445,118.06008c2.47967,4.02767 5.17433,7.88692 10.88258,7.88692c4.7945,0 7.31,-2.38292 7.31,-5.67958c0,-3.94525 -2.6015,-5.34633 -7.87617,-7.64325l-2.89175,-1.23267c-8.34558,-3.54033 -13.89617,-7.9765 -13.89617,-17.34692c0,-8.63583 6.61125,-15.20767 16.942,-15.20767c7.35658,0 12.642,2.54775 16.45467,9.21992l-9.0085,5.75842c-1.98158,-3.54033 -4.12442,-4.93425 -7.44617,-4.93425c-3.38983,0 -5.53625,2.13925 -5.53625,4.93425c0,3.45433 2.15,4.85183 7.11292,6.99108l2.89175,1.23267c9.83625,4.18892 15.38325,8.46742 15.38325,18.08508c0,10.363 -8.18433,16.04258 -19.17083,16.04258c-10.74642,0 -16.84883,-5.39292 -20.24583,-12.06867zM64.328,118.35392c1.81317,3.2465 4.56875,5.74408 8.53192,5.74408c3.79117,0 5.97342,-1.49783 5.97342,-7.32075v-37.94392h11.94325v39.77858c0,12.06508 -6.99825,17.55475 -17.21792,17.55475c-9.23425,0 -15.89925,-6.2565 -18.61542,-12.06867z",
    fill: "#000001"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none",
    stroke: "none",
    strokeWidth: 1,
    strokeLinejoin: "miter"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascriptIcon);
export default __webpack_public_path__ + "static/media/javascript-icon.fcbde848d004eb7ed18d21db0b7aa7d5.svg";
export { ForwardRef as ReactComponent };